function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var NFTOverlayTemplate = require('./nft-overlay.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoContacts = require('./../../modals/saito-contacts/saito-contacts');
var NFTAtomize = require('./nft-atomize');
var NFTCapabilities = require('./nft-capabilities');
var NFTOverlay = /*#__PURE__*/function () {
  function NFTOverlay(app, mod) {
    var _app$browser,
      _this = this;
    var attach_events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, NFTOverlay);
    this.app = app;
    this.mod = mod;
    if (app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.addStylesheet) {
      app.browser.addStylesheet('/saito/css-imports/ui/saito-nft.css');
    }
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.contacts = new SaitoContacts(this.app, this.mod);
    this.capabilities = new NFTCapabilities(this.app, this.mod, this);
    this.overlay.callback_on_close = function () {
      _this.stopExpiresTimer();
      if (_this.atomizer) {
        _this.atomizer.shutdown();
      }
    };

    //
    // ui helpers
    //
    this.nft = null;
    this.expires_timer = null;
    if (attach_events == true) {
      app.connection.on('saito-nft-details-render-request', function (nft) {
        _this.render(nft);
      });
      app.connection.on('saito-nft-details-close-request', function () {
        _this.overlay.close();
      });

      //app.connection.on('saito-disable-nft', (obj) => {
      // obj.nft_id
      // obj.nft_sig
      //});

      //app.connection.on('saito-enable-nft', (obj) => {
      // obj.nft_id
      // obj.nft_sig
      //});
    }
  }
  return _createClass(NFTOverlay, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var nft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.stopExpiresTimer();
      if (nft) {
        this.nft = nft;
      }
      this.overlay.show(NFTOverlayTemplate(this.app, this.mod, this));
      if (!this.nft.tx_fetched) {
        this.nft.fetchTransaction(function () {
          console.log('Rerendering nft overlay after fetching data');
          _this2.render();
        });
        return;
      }
      this.startExpiresTimer();

      // We need to kick this off, so that any child class can finish
      // rendering it's changes to the base class
      setTimeout(function () {
        _this2.attachBaseEvent();
        _this2.attachEvents();
      }, 25);
    }
  }, {
    key: "attachBaseEvent",
    value: function attachBaseEvent() {
      var _this3 = this;
      var info_back_btn = document.querySelector('.saito-nft-info-back');
      if (info_back_btn) {
        info_back_btn.onclick = function (e) {
          var _document$querySelect, _this3$capabilities;
          e.preventDefault();
          (_document$querySelect = document.querySelector('.saito-nft-overlay.panels')) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove('saito-nft-mode-info');
          (_this3$capabilities = _this3.capabilities) === null || _this3$capabilities === void 0 || _this3$capabilities.setActive('');
        };
      }
      var merge_btn = document.querySelector('.saito-nft-footer-btn.merge');
      //
      // MERGE button
      //
      if (merge_btn) {
        merge_btn.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var c;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return sconfirm('Merge all copies of NFT into a single one?');
                case 1:
                  c = _context.v;
                  if (c) {
                    _this3.mergeNFT();
                  }
                // no interstitial
                //document.querySelector('.saito-nft-overlay.panels').classList.add('saito-nft-mode-merge');
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
      var delete_info_btn = document.querySelector('.nft-info-delete-nft');
      if (delete_info_btn) {
        delete_info_btn.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var idx, z, _this3$all_slips$z$sl, c, newtx;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                idx = -1;
                z = 0;
              case 1:
                if (!(z < _this3.all_slips.length)) {
                  _context2.n = 3;
                  break;
                }
                if (!(_this3.mod.publicKey == ((_this3$all_slips$z$sl = _this3.all_slips[z].slip2) === null || _this3$all_slips$z$sl === void 0 ? void 0 : _this3$all_slips$z$sl.public_key))) {
                  _context2.n = 2;
                  break;
                }
                idx = z;
                return _context2.a(3, 3);
              case 2:
                z++;
                _context2.n = 1;
                break;
              case 3:
                if (!(idx < 0)) {
                  _context2.n = 4;
                  break;
                }
                return _context2.a(2);
              case 4:
                _this3.nft.resetNFT(_this3.all_slips[idx]);
                _context2.n = 5;
                return sconfirm("Delete this NFT and recover ".concat(_this3.app.wallet.convertNolanToSaito(_this3.nft.deposit), " SAITO?"));
              case 5:
                c = _context2.v;
                if (c) {
                  _context2.n = 6;
                  break;
                }
                return _context2.a(2);
              case 6:
                _context2.n = 7;
                return _this3.app.wallet.createRemoveNFTTransaction(_this3.nft);
              case 7:
                newtx = _context2.v;
                _context2.n = 8;
                return newtx.sign();
              case 8:
                _context2.n = 9;
                return _this3.app.network.propagateTransaction(newtx);
              case 9:
                _this3.app.storage.deleteTransaction(_this3.nft.tx, null, 'localhost');
                siteMessage('NFT Deletion in Process...', 2000);
                _this3.overlay.close();
                _this3.app.connection.emit('saito-nft-list-close-request');
                if (document.querySelector('.saito-nft-list')) {
                  _this3.app.connection.emit('saito-nft-list-render-request');
                }
              case 10:
                return _context2.a(2);
            }
          }, _callee2);
        }));
      }

      //
      // split and deposit (info panel)
      //
      var _loop = function _loop() {
        var utxoIdx = z + 1;

        // Split button (works with both old and new structure)
        var splitBtn = document.querySelector(".utxo-split-btn[data-utxo-idx=\"".concat(utxoIdx, "\"]"));
        if (!splitBtn) {
          // Try new structure
          splitBtn = document.querySelector("#utxo_".concat(utxoIdx, " .utxo-split-btn"));
        }
        if (splitBtn) {
          splitBtn.onclick = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
              var idx, panel, overlay;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    idx = parseInt(e.currentTarget.getAttribute('data-utxo-idx')) - 1;
                    _this3.nft.resetNFT(_this3.all_slips[idx]);

                    // Hide all overlays first
                    document.querySelectorAll('.saito-nft-split-overlay').forEach(function (overlay) {
                      overlay.classList.remove('split-overlay-active');
                    });

                    // Remove active class from panel
                    panel = document.querySelector('.saito-nft-panel-info');
                    if (panel) {
                      panel.classList.remove('split-overlay-panel-active');
                    }

                    // Show the specific overlay for this UTXO
                    overlay = document.querySelector(".split-container-utxo-".concat(utxoIdx));
                    if (overlay) {
                      overlay.classList.add('split-overlay-active');
                      // Add active class to panel for CSS targeting
                      if (panel) {
                        panel.classList.add('split-overlay-panel-active');
                      }
                      _this3.showSplitOverlay(utxoIdx);
                    }
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x2) {
              return _ref3.apply(this, arguments);
            };
          }();
        }

        //
        // DELETE button
        //
        var delete_btn = document.querySelector(".utxo-delete-btn[data-utxo-idx=\"".concat(utxoIdx, "\"]"));
        if (delete_btn) {
          delete_btn.onclick = /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
              var idx, c, newtx;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    idx = parseInt(e.currentTarget.getAttribute('data-utxo-idx')) - 1;
                    _this3.nft.resetNFT(_this3.all_slips[idx]);
                    _context4.n = 1;
                    return sconfirm("Delete this NFT and recover ".concat(_this3.app.wallet.convertNolanToSaito(_this3.nft.deposit), " SAITO?"));
                  case 1:
                    c = _context4.v;
                    if (c) {
                      _context4.n = 2;
                      break;
                    }
                    return _context4.a(2);
                  case 2:
                    _context4.n = 3;
                    return _this3.app.wallet.createRemoveNFTTransaction(_this3.nft);
                  case 3:
                    newtx = _context4.v;
                    _context4.n = 4;
                    return newtx.sign();
                  case 4:
                    _context4.n = 5;
                    return _this3.app.network.propagateTransaction(newtx);
                  case 5:
                    //
                    // remove any copies of NFT from local archive
                    //
                    _this3.app.storage.deleteTransaction(_this3.nft.tx, null, 'localhost');
                    siteMessage('NFT Deletion in Process...', 2000);
                    _this3.overlay.close();

                    // Close the overlay listing your nfts
                    _this3.app.connection.emit('saito-nft-list-close-request');
                    if (document.querySelector('.saito-nft-list')) {
                      _this3.app.connection.emit('saito-nft-list-render-request');
                    }
                  case 6:
                    return _context4.a(2);
                }
              }, _callee4);
            }));
            return function (_x3) {
              return _ref4.apply(this, arguments);
            };
          }();
        }

        // Return button handler
        var returnBtn = document.querySelector(".split-return-button-utxo-".concat(utxoIdx));
        if (returnBtn) {
          returnBtn.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Hide the overlay
            var overlay = document.querySelector(".split-container-utxo-".concat(utxoIdx));
            if (overlay) {
              overlay.classList.remove('split-overlay-active');
            }
            // Remove active class from panel
            var panel = document.querySelector('.saito-nft-panel-info');
            if (panel) {
              panel.classList.remove('split-overlay-panel-active');
            }
          };
        }

        // Deposit button (works with both old and new structure)
        var depositBtn = document.querySelector(".utxo-deposit-btn[data-utxo-idx=\"".concat(utxoIdx, "\"]"));
        if (!depositBtn) {
          // Try new structure
          depositBtn = document.querySelector("#utxo_".concat(utxoIdx, " .utxo-deposit-btn"));
        }
        if (depositBtn) {
          depositBtn.onclick = /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
              var idx, depositAmount;
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    salert('Deposit functionality is not yet fully implemented. Please check wallet.createDepositNFTTransaction()');
                    return _context5.a(2);
                  case 1:
                    depositAmount = _context5.v;
                    if (!(!depositAmount || isNaN(Number(depositAmount)) || Number(depositAmount) <= 0)) {
                      _context5.n = 2;
                      break;
                    }
                    return _context5.a(2);
                  case 2:
                    try {
                      // Create deposit transaction
                      // Note: This may need to be implemented in the wallet module
                      // For now, we'll show an alert that this feature needs implementation
                      // TODO: Implement deposit transaction creation
                      // let tx = await this.app.wallet.createDepositNFTTransaction(deposit_nft, depositAmount);
                      // await tx.sign();
                      // await this.app.network.propagateTransaction(tx);
                      // siteMessage('Deposit transaction sent', 2000);
                      // this.render();
                    } catch (err) {
                      console.error(err);
                      salert('Failed to create deposit transaction: ' + ((err === null || err === void 0 ? void 0 : err.message) || err));
                    }
                  case 3:
                    return _context5.a(2);
                }
              }, _callee5);
            }));
            return function (_x4) {
              return _ref5.apply(this, arguments);
            };
          }();
        }
      };
      for (var z = 0; z < this.all_slips.length; z++) {
        _loop();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this$capabilities,
        _this4 = this;
      (_this$capabilities = this.capabilities) === null || _this$capabilities === void 0 || _this$capabilities.attachEvents();

      //
      // Capability action hooks (icons on artwork)
      //
      var send_btn = document.querySelector('.saito-nft-capability.send-nft');
      var enable_btn = document.querySelector('.saito-nft-capability.enable-nft');
      var disable_btn = document.querySelector('.saito-nft-capability.disable-nft');
      var sell_btn = document.querySelector('.saito-nft-capability.sell-nft');

      //
      // contextual confirm buttons
      //
      var cancel_send_btn = document.querySelector('.saito-nft-panel-send .saito-nft-send-back');
      var confirm_send_btn = document.querySelector('.saito-nft-panel-send .saito-nft-confirm-btn');
      var max_amount_btn = document.querySelector('.saito-nft-panel-send .nft-send-max-btn');
      var amount_input = document.querySelector('.saito-nft-panel-send #nft-send-amount');
      var recipient_input = document.querySelector('.saito-nft-panel-send #nft-receiver-address');
      var advanced_toggle = document.querySelector('.saito-nft-panel-send .nft-advanced-toggle');
      var advanced_container = document.querySelector('.saito-nft-panel-send .nft-advanced-options');
      var sending = false;
      var show_recipient_error = false;
      var escapeHTML = function escapeHTML() {
        var _this4$app;
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        if ((_this4$app = _this4.app) !== null && _this4$app !== void 0 && (_this4$app = _this4$app.browser) !== null && _this4$app !== void 0 && _this4$app.escapeHTML) {
          return _this4.app.browser.escapeHTML(String(value));
        }
        return String(value).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll(/'/g, '&#039;');
      };
      var availableAmount = function availableAmount() {
        var _this4$nft, _this4$nft$returnAllS;
        var total = 0n;
        var _iterator = _createForOfIteratorHelper(_this4.all_slips || ((_this4$nft = _this4.nft) === null || _this4$nft === void 0 || (_this4$nft$returnAllS = _this4$nft.returnAllSlips) === null || _this4$nft$returnAllS === void 0 ? void 0 : _this4$nft$returnAllS.call(_this4$nft)) || []),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var slip = _step.value;
            try {
              var _slip$slip;
              total += BigInt((slip === null || slip === void 0 || (_slip$slip = slip.slip1) === null || _slip$slip === void 0 ? void 0 : _slip$slip.amount) || 0);
            } catch (err) {
              var _slip$slip2;
              console.warn('Invalid NFT amount:', slip === null || slip === void 0 || (_slip$slip2 = slip.slip1) === null || _slip$slip2 === void 0 ? void 0 : _slip$slip2.amount);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return total;
      };
      var amountFormatOptions = {
        maxFractionDigits: 0,
        strictLocaleSeparators: true
      };
      var normalizeAmountInput = function normalizeAmountInput() {
        var strictLocaleSeparators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        if (!amount_input) {
          return {
            valid: false,
            normalized: ''
          };
        }
        var parsed = _this4.app.browser.formatLocaleAmountInputElement(amount_input, _objectSpread(_objectSpread({}, amountFormatOptions), {}, {
          strictLocaleSeparators: strictLocaleSeparators
        }));

        // The formatter strips non-numeric characters when a number is present. If the
        // input contains no number at all, clear it instead of leaving invalid text behind.
        if (!parsed.valid && amount_input.value) {
          amount_input.value = amount_input.value.replace(/\D/g, '');
          parsed = _this4.app.browser.formatLocaleAmountInputElement(amount_input, _objectSpread(_objectSpread({}, amountFormatOptions), {}, {
            strictLocaleSeparators: false
          }));
        }
        return parsed;
      };
      var getAmountInputValue = function getAmountInputValue() {
        if (!amount_input) {
          return '';
        }
        var parsed = _this4.app.browser.parseLocaleAmount(amount_input.value, amountFormatOptions);
        return parsed.valid ? parsed.normalized : '';
      };
      var validateAmount = function validateAmount() {
        var _amount_input$value;
        var raw = (amount_input === null || amount_input === void 0 || (_amount_input$value = amount_input.value) === null || _amount_input$value === void 0 ? void 0 : _amount_input$value.trim()) || '';
        if (!raw) {
          return {
            valid: false,
            value: null,
            message: ''
          };
        }
        var normalized = getAmountInputValue();
        if (!normalized) {
          return {
            valid: false,
            value: null,
            message: 'Enter a whole number of NFT units'
          };
        }
        try {
          var value = BigInt(normalized);
          var balance = availableAmount();
          if (value <= 0n) {
            return {
              valid: false,
              value: value,
              message: 'Amount must be greater than 0'
            };
          }
          if (value > balance) {
            var balanceDisplay = _this4.app.browser.formatLocaleAmount(balance.toString(), {
              maxFractionDigits: 0,
              strictLocaleSeparators: false
            });
            return {
              valid: false,
              value: value,
              message: "Insufficient NFT units (".concat(balanceDisplay, " available)")
            };
          }
          return {
            valid: true,
            value: value,
            message: 'Amount is available'
          };
        } catch (err) {
          return {
            valid: false,
            value: null,
            message: 'Enter a valid NFT amount'
          };
        }
      };
      var showRecipientInput = function showRecipientInput() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$preserveValue = _ref6.preserveValue,
          preserveValue = _ref6$preserveValue === void 0 ? false : _ref6$preserveValue;
        var preview = document.getElementById('nft-recipient-status');
        var inputRow = recipient_input === null || recipient_input === void 0 ? void 0 : recipient_input.closest('.nft-recipient-input-row');
        preview === null || preview === void 0 || preview.classList.add('hide-element');
        inputRow === null || inputRow === void 0 || inputRow.classList.remove('hide-element');
        if (recipient_input) {
          if (!preserveValue) {
            recipient_input.value = '';
          }
          show_recipient_error = false;
          recipient_input.setAttribute('aria-invalid', 'false');
          recipient_input.focus();
        }
        updateSendForm();
      };
      var attachRecipientEditEvent = function attachRecipientEditEvent() {
        var preserveValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var editBtn = document.getElementById('nft-recipient-edit');
        if (!editBtn) {
          return;
        }
        editBtn.onclick = function (e) {
          e.preventDefault();
          showRecipientInput({
            preserveValue: preserveValue
          });
        };
      };
      var renderRecipientStatus = function renderRecipientStatus(recipient, valid) {
        var preview = document.getElementById('nft-recipient-status');
        var inputRow = recipient_input === null || recipient_input === void 0 ? void 0 : recipient_input.closest('.nft-recipient-input-row');
        if (!preview) {
          return;
        }
        if (!recipient || !valid && !show_recipient_error) {
          preview.innerHTML = '';
          preview.classList.add('hide-element');
          inputRow === null || inputRow === void 0 || inputRow.classList.remove('hide-element');
          return;
        }
        if (!valid) {
          preview.innerHTML = "\n          <div class=\"nft-recipient-invalid\" role=\"alert\">\n            <div class=\"nft-recipient-invalid-message\">Error: Invalid Saito address</div>\n            <button type=\"button\" class=\"saito-icon-button nft-recipient-edit\" id=\"nft-recipient-edit\" title=\"Edit recipient address\" aria-label=\"Edit recipient address\">\n              <i class=\"fa-solid fa-pen\" aria-hidden=\"true\"></i>\n            </button>\n          </div>\n        ";
          inputRow === null || inputRow === void 0 || inputRow.classList.add('hide-element');
          preview.classList.remove('hide-element');
          attachRecipientEditEvent(true);
          return;
        }
        var registeredIdentifier = _this4.app.keychain.returnIdentifierByPublicKey(recipient);
        var identifier = registeredIdentifier && registeredIdentifier !== recipient ? registeredIdentifier : '';
        var primary = identifier || recipient;
        var secondary = identifier ? recipient : 'anonymous user';
        var identicon = _this4.app.keychain.returnIdenticon(recipient);
        preview.innerHTML = "\n        <div class=\"saito-user nft-recipient-user\" data-id=\"".concat(escapeHTML(recipient), "\" data-disable=\"true\">\n          <div class=\"saito-identicon-box\">\n            <img class=\"saito-identicon\" src=\"").concat(escapeHTML(identicon), "\" alt=\"\">\n          </div>\n          <div class=\"saito-address\" title=\"").concat(escapeHTML(primary), "\">").concat(escapeHTML(primary), "</div>\n          <div class=\"saito-userline\" title=\"").concat(escapeHTML(secondary), "\">").concat(escapeHTML(secondary), "</div>\n          <button type=\"button\" class=\"saito-icon-button nft-recipient-edit\" id=\"nft-recipient-edit\" title=\"Edit recipient address\" aria-label=\"Edit recipient address\">\n            <i class=\"fa-solid fa-pen\" aria-hidden=\"true\"></i>\n          </button>\n        </div>\n      ");
        inputRow === null || inputRow === void 0 || inputRow.classList.add('hide-element');
        preview.classList.remove('hide-element');
        attachRecipientEditEvent(false);
      };
      var updateSendForm = function updateSendForm() {
        var _recipient_input$valu, _amount_input$value3;
        var recipient = (recipient_input === null || recipient_input === void 0 || (_recipient_input$valu = recipient_input.value) === null || _recipient_input$valu === void 0 ? void 0 : _recipient_input$valu.trim()) || '';
        var recipientValid = Boolean(recipient && _this4.app.crypto.isPublicKey(recipient));
        var amount = validateAmount();
        var amountStatus = document.getElementById('nft-amount-status');
        renderRecipientStatus(recipient, recipientValid);
        recipient_input === null || recipient_input === void 0 || recipient_input.setAttribute('aria-invalid', recipient && !recipientValid ? 'true' : 'false');
        if (amountStatus) {
          var _amount_input$value2;
          var hasAmount = Boolean(amount_input === null || amount_input === void 0 || (_amount_input$value2 = amount_input.value) === null || _amount_input$value2 === void 0 ? void 0 : _amount_input$value2.trim());
          var tooltip = document.getElementById('nft-amount-tooltip');
          var icon = amountStatus.querySelector('i');
          amountStatus.classList.toggle('hide-element', !hasAmount);
          amountStatus.classList.toggle('valid', hasAmount && amount.valid);
          amountStatus.classList.toggle('invalid', hasAmount && !amount.valid);
          amountStatus.tabIndex = hasAmount && !amount.valid ? 0 : -1;
          amountStatus.setAttribute('aria-label', hasAmount ? amount.valid ? 'Amount can be sent' : amount.message : '');
          if (icon) {
            icon.className = amount.valid ? 'fa-solid fa-check' : 'fa-solid fa-xmark';
          }
          max_amount_btn === null || max_amount_btn === void 0 || max_amount_btn.classList.toggle('hide-element', hasAmount);
          if (tooltip) {
            tooltip.textContent = hasAmount && !amount.valid ? amount.message : '';
          }
          if (hasAmount && !amount.valid) {
            amountStatus.setAttribute('aria-describedby', 'nft-amount-tooltip');
            amount_input === null || amount_input === void 0 || amount_input.setAttribute('aria-describedby', 'nft-amount-tooltip');
          } else {
            amountStatus.removeAttribute('aria-describedby');
            amount_input === null || amount_input === void 0 || amount_input.removeAttribute('aria-describedby');
          }
        }
        amount_input === null || amount_input === void 0 || amount_input.setAttribute('aria-invalid', amount_input !== null && amount_input !== void 0 && (_amount_input$value3 = amount_input.value) !== null && _amount_input$value3 !== void 0 && _amount_input$value3.trim() && !amount.valid ? 'true' : 'false');
        if (confirm_send_btn) {
          var disabled = sending || !recipientValid || !amount.valid;
          confirm_send_btn.disabled = disabled;
          confirm_send_btn.classList.toggle('disabled-btn', disabled);
        }
        return {
          recipient: recipient,
          recipientValid: recipientValid,
          amount: amount
        };
      };
      var shardMode = function shardMode() {
        return !!(advanced_container && !advanced_container.classList.contains('collapsed'));
      };
      var syncAmountToSelectedShard = function syncAmountToSelectedShard() {
        var _this4$all_slips, _this4$all_slips$i;
        var sel = document.querySelector('.saito-nft-panel-send .selected-shard');
        if (!sel || !amount_input || !((_this4$all_slips = _this4.all_slips) !== null && _this4$all_slips !== void 0 && _this4$all_slips.length)) {
          return;
        }
        var i = parseInt(sel.getAttribute('data-utxo-idx'), 10) - 1;
        var a = (_this4$all_slips$i = _this4.all_slips[i]) === null || _this4$all_slips$i === void 0 || (_this4$all_slips$i = _this4$all_slips$i.slip1) === null || _this4$all_slips$i === void 0 ? void 0 : _this4$all_slips$i.amount;
        amount_input.value = a == null ? '0' : typeof a === 'bigint' ? a.toString() : String(a);
        normalizeAmountInput(false);
        updateSendForm();
      };

      // enable / disable visibility is owned by NFTCapabilities.list()

      if (advanced_toggle && advanced_container) {
        advanced_toggle.onclick = function (e) {
          e.preventDefault();
          advanced_container.classList.toggle('collapsed');
          advanced_toggle.setAttribute('aria-expanded', advanced_container.classList.contains('collapsed') ? 'false' : 'true');
          if (amount_input && max_amount_btn) {
            var sm = shardMode();
            amount_input.readOnly = sm;
            max_amount_btn.disabled = sm;
            if (sm) {
              syncAmountToSelectedShard();
            } else {
              updateSendForm();
            }
          }
        };
      }
      if (max_amount_btn && amount_input) {
        max_amount_btn.onclick = function (e) {
          e.preventDefault();
          if (shardMode()) {
            salert('Disable Advanced Options to use MAX or set a custom amount. Shard mode sends the full selected shard.');
            return;
          }
          amount_input.value = availableAmount().toString();
          normalizeAmountInput(false);
          updateSendForm();
        };
      }
      if (recipient_input) {
        recipient_input.oninput = function () {
          show_recipient_error = false;
          updateSendForm();
        };
        recipient_input.onblur = function () {
          show_recipient_error = true;
          updateSendForm();
        };
      }
      if (amount_input) {
        amount_input.onbeforeinput = function (e) {
          if (e.inputType === 'insertText' && e.data && !/^\d+$/.test(e.data)) {
            e.preventDefault();
          }
        };
        amount_input.oninput = function () {
          normalizeAmountInput();
          updateSendForm();
        };
        amount_input.onpaste = function () {
          setTimeout(function () {
            normalizeAmountInput(false);
            updateSendForm();
          }, 0);
        };
        amount_input.onchange = function () {
          normalizeAmountInput();
          updateSendForm();
        };
        amount_input.onblur = function () {
          normalizeAmountInput();
          updateSendForm();
        };
      }
      var applyRecipient = function applyRecipient(value) {
        if (!recipient_input) {
          return;
        }
        recipient_input.value = typeof value === 'string' ? value.trim() : '';
        show_recipient_error = true;
        updateSendForm();
      };
      var paste_address_btn = document.getElementById('nft-paste-address');
      if (paste_address_btn) {
        paste_address_btn.onclick = /*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
            var _t, _t2;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.p = _context6.n) {
                case 0:
                  e.preventDefault();
                  _context6.p = 1;
                  _t = applyRecipient;
                  _context6.n = 2;
                  return navigator.clipboard.readText();
                case 2:
                  _t(_context6.v);
                  _context6.n = 4;
                  break;
                case 3:
                  _context6.p = 3;
                  _t2 = _context6.v;
                  console.warn('NFT recipient paste:', _t2);
                  recipient_input === null || recipient_input === void 0 || recipient_input.focus();
                  siteMessage('Clipboard access unavailable. Tap and hold the address field to paste.', 3000);
                case 4:
                  return _context6.a(2);
              }
            }, _callee6, null, [[1, 3]]);
          }));
          return function (_x5) {
            return _ref7.apply(this, arguments);
          };
        }();
      }
      var scan_address_btn = document.getElementById('nft-scan-address');
      if (scan_address_btn) {
        scan_address_btn.onclick = function (e) {
          e.preventDefault();
          _this4.app.connection.emit('scanner-start-scanner', function (data) {
            return applyRecipient(data);
          });
        };
      }
      var address_book_btn = document.getElementById('nft-address-book');
      if (address_book_btn) {
        address_book_btn.onclick = function (e) {
          e.preventDefault();
          _this4.contacts.title = 'Saito Contacts';
          _this4.contacts.callback = function (publicKey) {
            return applyRecipient(publicKey);
          };
          var contacts = _this4.app.keychain.returnKeys().filter(function (key) {
            return !(key !== null && key !== void 0 && key.group) && _this4.app.crypto.isPublicKey((key === null || key === void 0 ? void 0 : key.publicKey) || '');
          }).map(function (key) {
            return key.publicKey;
          });
          _this4.contacts.render(contacts);
        };
      }

      //
      // SEND NFT
      //
      if (confirm_send_btn) {
        // Select a shard
        Array.from(document.querySelectorAll('.saito-nft-panel-send .nft-slip-box')).forEach(function (box) {
          box.onclick = function (e) {
            if (!e.currentTarget.classList.contains('selected-shard')) {
              var _document$querySelect2;
              (_document$querySelect2 = document.querySelector('.saito-nft-panel-send .selected-shard')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('selected-shard');
              e.currentTarget.classList.add('selected-shard');
            }
            if (shardMode()) {
              syncAmountToSelectedShard();
            }
          };
        });

        // Click to send
        confirm_send_btn.onclick = /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
            var form, receiver, is_advanced_open, newtx, selected_shard, idx, tx_msg, _t3;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.p = _context7.n) {
                case 0:
                  e.preventDefault();
                  show_recipient_error = true;
                  form = updateSendForm();
                  receiver = form.recipient;
                  is_advanced_open = advanced_container && !advanced_container.classList.contains('collapsed');
                  if (!(!form.recipientValid || !form.amount.valid || sending)) {
                    _context7.n = 1;
                    break;
                  }
                  return _context7.a(2);
                case 1:
                  sending = true;
                  updateSendForm();
                  _context7.p = 2;
                  newtx = null;
                  if (!is_advanced_open) {
                    _context7.n = 6;
                    break;
                  }
                  selected_shard = document.querySelector('.saito-nft-panel-send .selected-shard');
                  if (selected_shard) {
                    _context7.n = 3;
                    break;
                  }
                  salert('Please select which shard you want to send');
                  return _context7.a(2);
                case 3:
                  idx = parseInt(selected_shard.getAttribute('data-utxo-idx')) - 1;
                  _this4.nft.resetNFT(_this4.all_slips[idx]);
                case 4:
                  if (amount_input) {
                    syncAmountToSelectedShard();
                  }
                  _context7.n = 5;
                  return _this4.app.wallet.createNFTShardTransaction(_this4.nft, receiver);
                case 5:
                  newtx = _context7.v;
                  _context7.n = 8;
                  break;
                case 6:
                  tx_msg = JSON.parse(JSON.stringify(_this4.nft.txmsg || {}));
                  _context7.n = 7;
                  return _this4.app.wallet.createNFTTransaction(_this4.nft, receiver, form.amount.value.toString(), BigInt(0), BigInt(0), tx_msg);
                case 7:
                  newtx = _context7.v;
                case 8:
                  _context7.n = 9;
                  return _this4.nft.modifyBeforeSend(newtx, receiver);
                case 9:
                  newtx = _context7.v;
                  if (newtx) {
                    _context7.n = 10;
                    break;
                  }
                  return _context7.a(2);
                case 10:
                  _context7.n = 11;
                  return newtx.sign();
                case 11:
                  _context7.n = 12;
                  return _this4.app.network.propagateTransaction(newtx);
                case 12:
                  siteMessage("NFT sent to ".concat(receiver), 3000);
                  _this4.overlay.close();
                  if (document.querySelector('.saito-nft-list')) {
                    _this4.app.connection.emit('saito-nft-list-render-request');
                  }
                  _context7.n = 14;
                  break;
                case 13:
                  _context7.p = 13;
                  _t3 = _context7.v;
                  console.error(_t3);
                  salert('Failed to send NFT');
                case 14:
                  _context7.p = 14;
                  sending = false;
                  updateSendForm();
                  return _context7.f(14);
                case 15:
                  return _context7.a(2);
              }
            }, _callee7, null, [[2, 13, 14, 15]]);
          }));
          return function (_x6) {
            return _ref8.apply(this, arguments);
          };
        }();
      }
      updateSendForm();

      //
      // SEND button
      //
      if (send_btn) {
        send_btn.onclick = function (e) {
          var _document$querySelect3, _document$querySelect4, _this4$capabilities;
          (_document$querySelect3 = document.querySelector('.saito-nft-overlay.panels')) === null || _document$querySelect3 === void 0 || _document$querySelect3.classList.add('saito-nft-mode-send');
          (_document$querySelect4 = document.querySelector('.saito-nft-overlay.panels')) === null || _document$querySelect4 === void 0 || _document$querySelect4.classList.remove('saito-nft-mode-info');
          (_this4$capabilities = _this4.capabilities) === null || _this4$capabilities === void 0 || _this4$capabilities.setActive('transfer');
        };
      }
      if (cancel_send_btn) {
        cancel_send_btn.onclick = function (e) {
          var _document$querySelect5, _this4$capabilities2;
          (_document$querySelect5 = document.querySelector('.saito-nft-overlay.panels')) === null || _document$querySelect5 === void 0 || _document$querySelect5.classList.remove('saito-nft-mode-send');
          (_this4$capabilities2 = _this4.capabilities) === null || _this4$capabilities2 === void 0 || _this4$capabilities2.setActive('');
        };
      }

      //
      // Enable button
      //
      if (enable_btn) {
        enable_btn.onclick = function (e) {
          if (!_this4.app.options.permissions) _this4.app.options.permissions = {};
          if (!_this4.app.options.permissions.nfts) _this4.app.options.permissions.nfts = [];
          if (!_this4.app.options.permissions.nfts.includes(_this4.nft.tx_sig)) {
            _this4.app.options.permissions.nfts.push(_this4.nft.tx_sig);
            salert('NFT Activated for Next Reload');
            _this4.app.storage.saveOptions();
          }
          _this4.app.connection.emit('saito-enable-nft', {
            nft_id: _this4.nft.id,
            nft_sig: _this4.nft.tx_sig
          });
          _this4.render();
        };
      }

      //
      // Disable button
      //
      if (disable_btn) {
        disable_btn.onclick = function (e) {
          if (!_this4.app.options.permissions) _this4.app.options.permissions = {};
          if (!_this4.app.options.permissions.nfts) _this4.app.options.permissions.nfts = [];
          _this4.app.options.permissions.nfts = _this4.app.options.permissions.nfts.filter(function (v) {
            return v !== _this4.nft.tx_sig;
          });
          _this4.app.connection.emit('saito-disable-nft', {
            nft_id: _this4.nft.id,
            nft_sig: _this4.nft.tx_sig
          });
          salert('NFT Disabled for Next Reload');
          _this4.app.storage.saveOptions();
          _this4.render();
        };
      }

      //
      // Sell on Store
      //
      var seller = this.app.modules.returnFirstRespondTo('saito-sell-nft');
      if (sell_btn && seller) {
        sell_btn.onclick = function (e) {
          seller.render({
            nft: _this4.nft,
            callback: function callback(obj) {
              if (obj.status === 'listed') {
                _this4.overlay.close();
                if (document.querySelector('.saito-nft-list')) {
                  _this4.app.connection.emit('saito-nft-list-render-request');
                }
              }
            }
          });
        };
      }
    }
  }, {
    key: "mergeNFT",
    value: function () {
      var _mergeNFT = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var tx, _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return this.app.wallet.createMergeNFTTransaction(this.nft);
            case 1:
              tx = _context8.v;
              _context8.n = 2;
              return tx.sign();
            case 2:
              _context8.n = 3;
              return this.app.network.propagateTransaction(tx);
            case 3:
              if (!this.app.options.wallet.nftMergeIntents) {
                this.app.options.wallet.nftMergeIntents = {};
              }
              this.app.options.wallet.nftMergeIntents[this.nft.id] = Date.now();
              this.app.wallet.saveWallet();
              siteMessage('Merge NFT tx sent', 2000);
              this.overlay.close();
              if (document.querySelector('.saito-nft-list')) {
                this.app.connection.emit('saito-nft-list-render-request');
              }
              _context8.n = 5;
              break;
            case 4:
              _context8.p = 4;
              _t4 = _context8.v;
              console.error(_t4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 4]]);
      }));
      function mergeNFT() {
        return _mergeNFT.apply(this, arguments);
      }
      return mergeNFT;
    }() //
    // Decode slip3.public_key to extract original creation block_id and tx_ordinal
    //
  }, {
    key: "decodeSlip3CreationInfo",
    value: function decodeSlip3CreationInfo() {
      var _this$nft;
      if (!((_this$nft = this.nft) !== null && _this$nft !== void 0 && (_this$nft = _this$nft.slip3) !== null && _this$nft !== void 0 && _this$nft.public_key)) {
        return {
          block_id: null,
          tx_ordinal: null
        };
      }
      try {
        var _this$app;
        // Use the NFT's base58ToBytes method if available, otherwise use our own
        var bytes = null;
        if (this.nft.base58ToBytes) {
          bytes = this.nft.base58ToBytes(this.nft.slip3.public_key);
        } else if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.crypto) !== null && _this$app !== void 0 && _this$app.fromBase58) {
          // Use app's crypto utility
          var hex = this.app.crypto.fromBase58(this.nft.slip3.public_key);
          bytes = this.hexToBytes(hex);
        } else {
          // Fallback: try to use hex if it's already bytes
          if (typeof this.nft.slip3.public_key === 'string' && /^[0-9a-fA-F]{66}$/.test(this.nft.slip3.public_key)) {
            bytes = this.hexToBytes(this.nft.slip3.public_key);
          } else {
            // Try our own base58 decoder
            bytes = this.base58ToBytes(this.nft.slip3.public_key);
          }
        }
        if (!bytes || bytes.length < 16) {
          return {
            block_id: null,
            tx_ordinal: null
          };
        }

        // Extract block_id (bytes 0-7, big-endian u64)
        var blockIdBytes = bytes.slice(0, 8);
        var block_id = 0n;
        for (var i = 0; i < 8; i++) {
          block_id = block_id << 8n | BigInt(blockIdBytes[i]);
        }

        // Extract tx_ordinal (bytes 8-15, big-endian u64)
        var txOrdBytes = bytes.slice(8, 16);
        var tx_ordinal = 0n;
        for (var _i = 0; _i < 8; _i++) {
          tx_ordinal = tx_ordinal << 8n | BigInt(txOrdBytes[_i]);
        }
        return {
          block_id: block_id.toString(),
          tx_ordinal: tx_ordinal.toString()
        };
      } catch (err) {
        console.error('Error decoding slip3 creation info:', err);
        return {
          block_id: null,
          tx_ordinal: null
        };
      }
    }

    //
    // Helper to convert hex string to bytes
    //
  }, {
    key: "hexToBytes",
    value: function hexToBytes(hex) {
      var clean = hex.startsWith('0x') ? hex.slice(2) : hex;
      var out = new Uint8Array(clean.length / 2);
      for (var i = 0; i < out.length; i++) {
        out[i] = parseInt(clean.substr(i * 2, 2), 16);
      }
      return out;
    }

    //
    // Base58 decoder (fallback if NFT doesn't have it)
    //
  }, {
    key: "base58ToBytes",
    value: function base58ToBytes(str) {
      var B58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
      var B58_MAP = function () {
        var m = new Map();
        for (var i = 0; i < B58_ALPHABET.length; i++) m.set(B58_ALPHABET[i], i);
        return m;
      }();
      var zeros = 0;
      while (zeros < str.length && str[zeros] === '1') zeros++;
      var bytes = [];
      for (var i = zeros; i < str.length; i++) {
        var val = B58_MAP.get(str[i]);
        if (val == null) throw new Error('Invalid Base58 character');
        var carry = val;
        for (var j = 0; j < bytes.length; j++) {
          var x = bytes[j] * 58 + carry;
          bytes[j] = x & 0xff;
          carry = x >> 8;
        }
        while (carry > 0) {
          bytes.push(carry & 0xff);
          carry >>= 8;
        }
      }
      for (var k = 0; k < zeros; k++) bytes.push(0);
      bytes.reverse();
      return new Uint8Array(bytes);
    }

    //
    // Extract metadata from txmsg (excluding data subobject, title, and description)
    //
  }, {
    key: "extractMetadata",
    value: function extractMetadata() {
      var _this$nft2;
      if (!((_this$nft2 = this.nft) !== null && _this$nft2 !== void 0 && _this$nft2.tx)) {
        return {};
      }
      var txmsg = this.nft.tx.returnMessage();
      if (!txmsg) {
        return {};
      }
      var metadata = {};
      var dataKeys = txmsg.data ? Object.keys(txmsg.data) : [];
      var excludeKeys = ['title', 'description'].concat(_toConsumableArray(dataKeys));
      for (var key in txmsg) {
        if (!excludeKeys.includes(key) && key !== 'data') {
          metadata[key] = txmsg[key];
        }
      }
      return metadata;
    }
  }, {
    key: "showSplitOverlay",
    value: function showSplitOverlay(utxoIdx) {
      var _this5 = this;
      if (!utxoIdx) {
        return;
      }
      var totalAmount = Number(this.nft.amount);
      if (!Number.isFinite(totalAmount) || totalAmount < 2) {
        salert('This NFT cannot be split (amount < 2).');
        return;
      }

      // Get the specific slider elements for this UTXO
      var slider = document.querySelector("#split-slider-utxo-".concat(utxoIdx));
      var leftDiv = document.querySelector("#split-left-utxo-".concat(utxoIdx));
      var bar = document.querySelector("#split-bar-utxo-".concat(utxoIdx));
      var rightDiv = document.querySelector("#split-right-utxo-".concat(utxoIdx));
      var leftNumberBox = document.querySelector("#split-number-left-utxo-".concat(utxoIdx));
      var rightNumberBox = document.querySelector("#split-number-right-utxo-".concat(utxoIdx));
      var confirmSplitButton = document.querySelector(".split-button-utxo-".concat(utxoIdx));
      var atomizeButton = document.querySelector(".atomize-button-utxo-".concat(utxoIdx));
      if (!slider || !leftDiv || !bar || !rightDiv || !leftNumberBox || !rightNumberBox || !confirmSplitButton) {
        console.error('Slider elements not found for UTXO', utxoIdx);
        return;
      }

      // Wait for layout to settle before calculating dimensions
      setTimeout(function () {
        //
        // GET REAL WIDTH
        //
        var parentWidth = slider.getBoundingClientRect().width;
        var barRect = bar.getBoundingClientRect();
        var barWidth = barRect.width;
        var usable = parentWidth - barWidth;
        var minW = 20;

        //
        // INITIAL VALUES
        //
        var leftCount = Math.round(totalAmount / 2);
        var rightCount = totalAmount - leftCount;
        var leftW = usable * (leftCount / totalAmount);
        var rightW = usable - leftW;
        leftDiv.style.width = leftW + 'px';
        rightDiv.style.width = rightW + 'px';

        // Update number boxes instead of split halves
        leftNumberBox.innerHTML = leftCount;
        rightNumberBox.innerHTML = rightCount;

        //
        // CONFIRM BUTTON
        //
        confirmSplitButton.onclick = /*#__PURE__*/function () {
          var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
            var L, T, R, tx, _t5;
            return _regenerator().w(function (_context9) {
              while (1) switch (_context9.p = _context9.n) {
                case 0:
                  e.preventDefault();
                  L = parseInt(leftNumberBox.innerText);
                  T = parseInt(_this5.nft.amount);
                  R = T - L;
                  _context9.p = 1;
                  _context9.n = 2;
                  return _this5.app.wallet.createSplitNFTTransaction(_this5.nft, L, R);
                case 2:
                  tx = _context9.v;
                  _context9.n = 3;
                  return tx.sign();
                case 3:
                  _context9.n = 4;
                  return _this5.app.network.propagateTransaction(tx);
                case 4:
                  siteMessage('Split NFT tx sent', 2000);
                  _this5.overlay.close();
                  if (document.querySelector('.saito-nft-list')) {
                    _this5.app.connection.emit('saito-nft-list-render-request');
                  }
                  _context9.n = 6;
                  break;
                case 5:
                  _context9.p = 5;
                  _t5 = _context9.v;
                  console.error(_t5);
                  _this5.app.browser.safeConsole('NFT: ', _this5.nft, 'debug');
                case 6:
                  return _context9.a(2);
              }
            }, _callee9, null, [[1, 5]]);
          }));
          return function (_x7) {
            return _ref9.apply(this, arguments);
          };
        }();
        if (atomizeButton) {
          atomizeButton.onclick = /*#__PURE__*/function () {
            var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(e) {
              var this_nft;
              return _regenerator().w(function (_context0) {
                while (1) switch (_context0.n) {
                  case 0:
                    _this5.atomize_in_progress = true;
                    this_nft = _this5.all_slips[utxoIdx - 1];
                    if (this_nft) {
                      _context0.n = 1;
                      break;
                    }
                    return _context0.a(2);
                  case 1:
                    _this5.atomizer_ui = new NFTAtomize(_this5.app, _this5.mod, '.split-container-utxo-' + utxoIdx, this_nft, utxoIdx);
                    _this5.atomizer_ui.render();
                  case 2:
                    return _context0.a(2);
                }
              }, _callee0);
            }));
            return function (_x8) {
              return _ref0.apply(this, arguments);
            };
          }();
        }

        //
        // DRAG FUNCTION
        //
        var drag = function drag(e) {
          var rect = slider.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var newLeftW = x;
          newLeftW = Math.max(minW, Math.min(newLeftW, usable - minW));
          var newRightW = usable - newLeftW;
          leftDiv.style.width = newLeftW + 'px';
          rightDiv.style.width = newRightW + 'px';
          leftCount = Math.round(newLeftW / usable * totalAmount);
          leftCount = Math.max(1, Math.min(leftCount, totalAmount - 1));
          rightCount = totalAmount - leftCount;

          // Update number boxes instead of split halves
          leftNumberBox.innerHTML = leftCount;
          rightNumberBox.innerHTML = rightCount;
        };

        //
        // ATTACH EVENT HANDLERS
        //
        bar.onmousedown = function (e) {
          e.preventDefault();
          e.stopPropagation();
          document.addEventListener('mousemove', drag);
          document.addEventListener('mouseup', function () {
            document.removeEventListener('mousemove', drag);
          }, {
            once: true
          });
        };

        // Ensure bar is clickable
        bar.style.pointerEvents = 'auto';
        bar.style.position = 'relative';
        bar.style.zIndex = '11';
      }, 50);
    }
  }, {
    key: "stopExpiresTimer",
    value: function stopExpiresTimer() {
      if (this.expires_timer) {
        clearInterval(this.expires_timer);
        this.expires_timer = null;
      }
    }
  }, {
    key: "startExpiresTimer",
    value: function startExpiresTimer() {
      var _this6 = this;
      this.stopExpiresTimer();
      if (!this.nft || this.nft.expires_at == null || this.nft.expires_at === '') {
        return;
      }
      this.tickExpiresClock();
      this.expires_timer = setInterval(function () {
        if (!document.querySelector('.saito-nft-image .saito-nft-expires-clock')) {
          _this6.stopExpiresTimer();
          return;
        }
        _this6.tickExpiresClock();
      }, 1000);
    }
  }, {
    key: "tickExpiresClock",
    value: function tickExpiresClock() {
      var clock = document.querySelector('.saito-nft-image .saito-nft-expires-clock');
      if (!clock || !this.nft) {
        this.stopExpiresTimer();
        return;
      }
      clock.textContent = this.nft.remainingExpiresLabel();
    }
  }]);
}();
module.exports = NFTOverlay;